/**
 * @module modules/split-chart-menu-sk
 * @description <h2><code>split-chart-menu-sk</code></h2>
 *
 * SplitChartMenuSk is a menu that contains the options for
 * splitting the chart by attribute. Example attributes are
 * benchmark, story, subtest, etc.
 *
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SplitChartMenuSk", {
    enumerable: true,
    get: function() {
        return SplitChartMenuSk;
    }
});
const _context = require("@lit/context");
const _lit = require("lit");
const _decorators = require("lit/decorators.js");
const _dataframe_context = require("../dataframe/dataframe_context");
const _traceset = require("../dataframe/traceset");
const _define = require("../../../elements-sk/modules/define");
const _splitchartmenuskcss = require("./split-chart-menu-sk.css");
const _json = require("../json");
require("@material/web/menu/menu.js");
require("@material/web/menu/menu-item.js");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let SplitChartMenuSk = class SplitChartMenuSk extends _lit.LitElement {
    menuClicked(e) {
        e.preventDefault();
        e.stopPropagation();
        this.menuOpen = !this.menuOpen;
    }
    menuClosed() {
        this.menuOpen = false;
    }
    render() {
        return (0, _lit.html)`
      <md-outlined-button id="menu-id" @click=${this.menuClicked}> Split By </md-outlined-button>
      <md-menu
        .open=${this.menuOpen}
        anchor="menu-id"
        positioning="fixed"
        quick="true"
        @closed=${this.menuClosed}>
        ${this.getAttributes().map((attr)=>(0, _lit.html)`
            <md-menu-item
              @click=${()=>{
                this.bubbleAttribute(attr);
            }}>
              ${attr}
            </md-menu-item>
          `)}
      </md-menu>
    `;
    }
    bubbleAttribute(attribute) {
        this.dispatchEvent(new CustomEvent('split-chart-selection', {
            bubbles: true,
            composed: true,
            detail: {
                attribute: attribute
            }
        }));
    }
    getAttributes() {
        if (!this.df) {
            return [];
        }
        return (0, _traceset.getAttributes)(this.df);
    }
    constructor(...args){
        super(...args);
        this.data = null;
        this.menuOpen = false;
    }
};
(()=>{
    SplitChartMenuSk.styles = _splitchartmenuskcss.style;
})();
_ts_decorate([
    (0, _context.consume)({
        context: _dataframe_context.dataframeContext,
        subscribe: true
    }),
    (0, _decorators.property)({
        attribute: false
    }),
    _ts_metadata("design:type", typeof _json.DataFrame === "undefined" ? Object : _json.DataFrame)
], SplitChartMenuSk.prototype, "df", void 0);
_ts_decorate([
    (0, _context.consume)({
        context: _dataframe_context.dataTableContext,
        subscribe: true
    }),
    (0, _decorators.property)({
        attribute: false
    }),
    _ts_metadata("design:type", typeof _dataframe_context.DataTable === "undefined" ? Object : _dataframe_context.DataTable)
], SplitChartMenuSk.prototype, "data", void 0);
_ts_decorate([
    (0, _decorators.state)()
], SplitChartMenuSk.prototype, "menuOpen", void 0);
(0, _define.define)('split-chart-menu-sk', SplitChartMenuSk);
